/**
 * Public WhatsApp button config — storefront floating chat widget.
 */
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { WhatsAppButtonConfig } from '@shared/types'

export function usePublicWhatsAppButton() {
  return useQuery({
    queryKey: ['cms-whatsapp-button'],
    queryFn: async () => {
      const { data } = await api.get<{ data: WhatsAppButtonConfig }>('/cms/whatsapp-button')
      return data.data
    },
    staleTime: 30 * 1000,
    retry: 1,
  })
}

export function buildWhatsAppChatUrl(phoneNumber: string, message?: string): string {
  const phone = phoneNumber.replace(/\D+/g, '')
  if (!phone) return 'https://wa.me/'
  const base = `https://wa.me/${phone}`
  if (!message?.trim()) return base
  return `${base}?text=${encodeURIComponent(message.trim())}`
}
